import BpkLink from '@skyscanner-internal/backpack-web/bpk-component-link';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import Icon, { ICON_SIZE } from '../common/Icon';

import type {
  InfoPanelProps,
  InfoPanelItemProps,
} from '@skyscanner-internal/landing-pages-shared-types/types-shared/InfoPanelProps';

import STYLES from './InfoPanel.module.scss';

const InfoPanelItem = ({ icon, label, link }: InfoPanelItemProps) => {
  const IconComponent = Icon(icon, ICON_SIZE.SMALL);

  return (
    <div className={STYLES.InfoPanelItem} data-testid="info-panel-item">
      <div className={STYLES.Icon}>
        <IconComponent />
      </div>
      <div className={STYLES.Label}>
        {link ? (
          <BpkLink href={link}>{label}</BpkLink>
        ) : (
          <BpkText>{label}</BpkText>
        )}
      </div>
    </div>
  );
};

export default function InfoPanel({
  leftColumnItems,
  rightColumnItems,
  title,
}: InfoPanelProps) {
  return (
    <div className={STYLES.InfoPanel}>
      <div className={STYLES.Title}>
        <BpkText tagName="h3" textStyle={TEXT_STYLES.editorial2}>
          {title}
        </BpkText>
      </div>
      <div className={STYLES.Panel}>
        {leftColumnItems && leftColumnItems.length > 0 && (
          <div className={STYLES.LeftColumn} data-testid="info-panel">
            {leftColumnItems.map((item) => (
              <InfoPanelItem key={item.label} {...item} />
            ))}
          </div>
        )}
        {rightColumnItems && rightColumnItems.length > 0 && (
          <div className={STYLES.RightColumn} data-testid="info-panel">
            {rightColumnItems.map((item) => (
              <InfoPanelItem key={item.label} {...item} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
